export const stateTypeList = [
  {
    label: "买家已还价 待卖家同意",
    value: "0",
  },
  {
    label: "卖家未同意 买家取消还价",
    value: "4",
  },
  {
    label: "卖家拒绝还价",
    value: "5",
  },
  {
    label: "卖家已同意 待买家支付",
    value: "1",
  },
  {
    label: "卖家已同意 卖家取消还价",
    value: "8",
  },
  {
    label: "卖家已同意 买家已支付尾款",
    value: "6",
  },
  {
    label: "卖家已同意 买家违约-未支付",
    value: "3",
  },
  {
    label: "卖家已同意 买家超时支付",
    value: "9",
  },
  {
    label: "卖家已同意 买家违约-取消还价",
    value: "7",
  },
  {
    label: "买家已违约，待确认周期中",
    value: "10",
  },
  {
    label: "系统取消还价",
    value: "12",
  },
];

export const columnsList = [
  {
    width: 130,
    title: "游戏名称",
    slot: "gameInfo",
    align: "center",
    fixed: "left",
  },
  {
    width: 120,
    title: "还价单号",
    key: "id",
    align: "center",
  },
  {
    width: 120,
    title: "商品原价",
    key: "commodity_price",
    align: "center",
  },
  {
    width: 120,
    title: "还价价格",
    key: "counter_offer_prince",
    align: "center",
  },
  {
    width: 120,
    title: "买家UID",
    key: "user_id",
    align: "center",
  },
  {
    width: 120,
    title: "买家账号",
    key: "user_account",
    align: "center",
  },
  {
    width: 120,
    title: "卖家UID",
    key: "seller_user_id",
    align: "center",
  },
  {
    width: 120,
    title: "卖家账号",
    key: "seller_user_account",
    align: "center",
  },
  {
    width: 150,
    title: "商品ID",
    key: "commodity_id",
    align: "center",
  },
  {
    width: 160,
    title: "状态",
    key: "status_txt",
    align: "center",
  },
  {
    width: 150,
    title: "买家发起还价时间",
    key: "counter_offer_time",
    align: "center",
  },
  {
    width: 150,
    title: "买家取消还价时间",
    key: "user_cancel_time",
    align: "center",
  },
  {
    width: 150,
    title: "卖家同意还价时间",
    key: "seller_agree_time",
    align: "center",
  },
  {
    width: 150,
    title: "卖家拒绝还价时间",
    key: "seller_refuse_time",
    align: "center",
  },
  {
    width: 150,
    title: "卖家取消还价时间",
    key: "seller_cancel",
    align: "center",
  },
  {
    width: 150,
    title: "还价到期时间",
    key: "seller_agree_end_time",
    align: "center",
  },
  {
    width: 150,
    title: "违约时间",
    key: "default_time",
    align: "center",
  },
  {
    width: 150,
    title: "卖家保证金金额",
    key: "seller_get_bond",
    align: "center",
    render: (h, params) => {
      const str =
        params.row.status === 3 || params.row.status === 7
          ? params.row.seller_get_bond
          : "";
      return h("div", str);
    },
  },
  {
    width: 150,
    title: "关联交易订单号",
    key: "order_no",
    align: "center",
  },
  {
    width: 150,
    title: "关联保证金订单号",
    key: "margin_order_num",
    align: "center",
  },
  {
    width: 150,
    title: "操作",
    slot: "action",
    align: "center",
  },
];
export const fieldList = [
  { name: "买家发起还价时间", key: "counter_offer_time", id: 1 },
  { name: "违约时间", key: "default_time", id: 2 },
];

const arr = ["0", "4", "5", "1", "8", "6", "12"];

export function onChange(val, list, type) {
  if (val === "default_time" && hasIntersection(arr, list)) {
    return true;
  } else if (
    val === "stateType" &&
    list === "default_time" &&
    arr.includes(type)
  ) {
    return true;
  }
  return false;
}

function hasIntersection(arr1, arr2) {
  return arr1.filter((item) => arr2.includes(item)).length > 0;
}
